import { Box, Skeleton, Typography } from '@customink/pigment-react';
import type { SxProps } from '@customink/project-service-react-components';
import type { ReactNode } from 'react';

type LineItemProps = {
  isLoading?: boolean;
  name: string | ReactNode;
  sxName?: SxProps;
  sxValue?: SxProps;
  tagPrefix?: string;
  value: string | ReactNode;
};

export function LineItem({
  name,
  value,
  isLoading,
  tagPrefix,
  sxName,
  sxValue,
}: LineItemProps) {
  return (
    <Box
      data-testid={`${tagPrefix}-line-item`}
      sx={{
        display: 'flex',
        gap: '0.5rem',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
    >
      <Typography
        data-testid={`${tagPrefix}-line-item-name`}
        sx={sxName}
        variant="uiTextDefault"
      >
        {name}
      </Typography>
      <Typography data-testid={`${tagPrefix}-line-item-value`} display="flex">
        {isLoading ? (
          <Skeleton
            data-testid={`${tagPrefix}-line-item-skeleton`}
            width={25}
          />
        ) : (
          <Typography sx={sxValue} variant="uiTextDefault">
            {value}
          </Typography>
        )}
      </Typography>
    </Box>
  );
}
